module.exports = __webpack_public_path__ + "static/promo_2-37d02db189c478ad92522144ecfec92c.png";